module.exports = __webpack_public_path__ + "static/img/Patient_Transaction_Log.29a7e76.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Patient_Transaction_Log.jpg
// module id = 2bnP
// module chunks = 0